import { Box, Button, Flex } from "@chakra-ui/react";
import MarkdownContent from "../../components/markdown-content";

export default function Affiliates() {
  return (
    <Box>
      <Box
        backgroundColor="#eee"
        bgImage={`url('/affiliate-program.jpeg')`}
        bgPosition="center"
        bgSize="cover"
        bgRepeat="no-repeat"
        w={"100%"}
        maxW="1072px"
        my={5}
        marginLeft="auto"
        marginRight="auto"
        height={{ base: "200px", md: "350px" }}
      ></Box>
      <MarkdownContent>
        {`
# Become a Friend of Talkio AI

Join the Friends of Talkio AI, our exciting affiliate program, and open up a world of opportunities. 
Whether you're a blogger, influencer, or simply a language enthusiast, you can turn your love for Talkio AI into rewards!

## Earn as you learn

By becoming a Friend of Talkio AI, you can earn a 30% commission on all payments within the first 12 months you refer to us. 
That's right, every time your referrals make a payment, you get to earn. It's as simple as that!

## Why Join Us?

Talkio AI is an innovative language training app that uses AI technology to help users improve their oral language skills. 
It offers an immersive language learning experience that is both engaging and effective. 
By becoming an affiliate, you'll not only earn, but also join us in our mission to make language learning more accessible and fun.

## How Does it Work?

Joining the Friends of Talkio AI is quick and easy. Follow these simple steps:

1. Sign up for our affiliate program.
2. Get your unique referral link.
3. Share this link on your blog, social media, or with your friends.
4. Earn a 30% recurring commission every time someone you refer makes a payment.

It's that easy! You can track your earnings and referrals through our easy-to-use affiliate dashboard via Rewardful.

Oh, and to make it even easier, we've put together a range of marketing materials for you to use: [download here](/files/talkio-kit.zip).

## FAQ
- *How do I get paid?* You'll receive your earnings via PayPal.
- *When do I get paid?* Payments are made monthly.
- *Is there a minimum payout threshold?* Yes, the minimum payout is $100.
- *How long does the cookie last?* The cookie lasts for 60 days.
- *Can I promote Talkio on coupon sites?* No, this is not allowed.
- *Can I run PPC campaigns using Talkio keywords?* No, this is not allowed.

## Be part of the Talkio journey!

Are you ready to join us in transforming the way people learn languages? Become a Friend of Talkio AI today and start earning!
  `}
      </MarkdownContent>

      <Flex justifyContent={"center"} mb={12} mt={"-20px"}>
        <Button
          size="xl"
          as="a"
          colorScheme={"brand.primary"}
          color={"#222"}
          href="https://aidia-aps.getrewardful.com/signup"
        >
          Sign up for affiliate program
        </Button>
      </Flex>
    </Box>
  );
}
